import axios from 'axios'
import qs from 'qs'
import config from './config'
import common from './common'

const service = axios.create({
    baseURL: (location.host == location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn') ? 'https://jb-api.scjb.gov.cn' : 'https://jb-cms.fm-dev.thecover.cn',
    // baseURL: (location.host == location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn' || location.host == 'piyao-web.fm-dev.thecover.cn') ? 'https://jb-cms.fm-dev.thecover.cn' : config.baseUrl,
    timeout: 10000
})

service.interceptors.request.use(
	config => {
		// 可自定义一些config配置, 可能会调价一些header头

		return config
	},
	error => {
		// 处理一些请求出错的情况

		console.log(error)
	}
)

service.interceptors.response.use(
	config => {
		// 可自定义一些config配置
		// 可处理接口状态码进行相关操作
		if(config.status == 200) {
			return config.data
		}
	},
	error => {
		// 处理一些请求出错的情况

		console.log(error)
	}
)

const AXIOSWAYS = {
	// get
	get: (url, params = {}) => {
		return new Promise((resolve, reject) => {
			service({
				method: 'get',
				url: url,
				params: params,
			}).then(res => {
				if(res.status == 0) {
					resolve(res.data)
				} else {
					// 全局的一个提示信息
				}
			}).catch(err => {
				reject(err)
			})
		})
	},

	// post
	post: (url, params = {}) => {
		return new Promise((resolve, reject) => {
			service({
				method: 'post',
				url: url,
				data: qs.stringify(params),
				// 也可以处理一些header头
				// headers: {
				// 	'Content-Type': 'application/x-www-form-urlencoded'
				// }
			}).then(res => {
				if(res.status == 0) {
					resolve(res.data)
				} else {
					// 全局的一个提示信息
				}
			}).catch(err => {
				reject(err)
			})
		})
	}
}

// 接口配置
const ApiInfo = {
	getWeChatConf: '/wap/counterRumour/weixin/getConf', // 获取微信分享配置信息
	// 新接口
	getSubjectList: '/api/zone/list', // 获取专题列表新闻 ---> 首页专区
	getColumnList: '/api/home/menu', // 获取栏目列表  ---> 顶部导航
	getChannelItemList: '/api/channel/itemList', // 获取栏目新闻列表 ---> 频道信息流列表
	getNewsDetail: '/api/news/get', // 获取新闻详情 ---> 普通新闻详情
	getSubjectDetail: '/api/subject/itemList', // 获取专题详情
	getSearchResult: '/api/piyao/search', // 获取搜索结果
	getSubjectChannelList: '/api/subject/subjectChannelList', // 获取专题分类列表
	getSubjectChannelMore: '/api/subject/subjectChannelMore', // 获取专题分类列表
	getLink: '/api/news/link/get', // 外链文章统计
	platformStatistic: '/api/platformStatistic/add', // 访问量统计
}
// if(common.Attribute.isMb()) { // 一开始以为wap接口要加上wap前缀，最后商定和pc走一样的接口
// 	for(let key in ApiInfo) {
// 		ApiInfo[key] = `wap${ApiInfo[key]}`
// 	}
// }

export { AXIOSWAYS, ApiInfo }